import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { getalldata, getMenuContent, getStoreSeries  } from "../api/service";
import { FaRegClock,FaTag  } from "react-icons/fa";
import { MdOutlineSort, MdArrowUpward, MdArrowDownward } from "react-icons/md";
const GLOBAL_CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;900&family=DM+Sans:wght@400;500;600;700&display=swap');

  * { box-sizing: border-box; margin: 0; padding: 0; -webkit-tap-highlight-color: transparent; }
  html, body, #root { height: 100%; background: #f5f0eb; }
html, body, #root {
  -webkit-text-size-adjust: 100%;
  -moz-text-size-adjust: 100%;
  text-size-adjust: 100%;
}
  :root {
    --red:#c8102e; --red-dk:#9b0d22; --red-lt:#fdecea;
    --cream:#f5f0eb; --charcoal:#1a1a1a; --slate:#4a4a4a;
    --muted:#9e9e9e; --white:#ffffff;
    --shadow:0 4px 20px rgba(0,0,0,0.10);
    --shadow-sm:0 2px 8px rgba(0,0,0,0.07);
    --radius:16px; --radius-sm:10px;
    --font-display:'Playfair Display',serif;
    --font-body:'DM Sans',system-ui,sans-serif;
  }

  .menu-root { font-family:var(--font-body); background:var(--cream); min-height:100vh; width:100%; margin:0; position:relative; display:flex; flex-direction:column; overflow:hidden; }

  .mh-header { background:var(--charcoal); padding:0 16px; position:sticky; top:0; z-index:100; box-shadow:0 2px 12px rgba(0,0,0,0.25); }
  .mh-top { display:flex; align-items:center; justify-content:space-between; height:60px; gap:10px; }
  .mh-logo { width:42px; height:42px; border-radius:50%; object-fit:cover; border:2px solid var(--red); flex-shrink:0; cursor:pointer; }
  .mh-logo-placeholder { width:42px; height:42px; border-radius:50%; background:var(--red); display:flex; align-items:center; justify-content:center; font-size:20px; flex-shrink:0; cursor:pointer; }
  .mh-info { flex:1; overflow:hidden; }
  .mh-store { font-size:15px; font-weight:700; color:#fff; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
  .mh-time { display: flex;align-items: center;  gap: 2px;font-size:18px; color:#ffffff; font-weight:600; flex-shrink:0; }

  .mh-banner { position:relative; height:180px; overflow:hidden; background:#222; }
  .mh-banner-img { width:100%; height:100%; object-fit:cover; transition:opacity 0.8s ease; position:absolute; inset:0; }
  .mh-banner-overlay { position:absolute; inset:0; background:linear-gradient(to top,rgba(0,0,0,0.6) 0%,transparent 60%); }
  .mh-banner-text { position:absolute; bottom:14px; left:16px; color:#fff; }
  .mh-banner-text h2 { font-family:var(--font-display); font-size:22px; font-weight:900; text-shadow:0 2px 8px rgba(0,0,0,0.5); }
  .mh-banner-text p { font-size:12px; color:#ddd; margin-top:2px; }

  .mh-search-wrap { padding:12px 16px 0; position:relative; }
  .mh-search { width:100%; background:#fff; border:1.5px solid #e8e0d8; border-radius:12px; padding:11px 40px 11px 40px; font-size:14px; font-family:var(--font-body); color:var(--charcoal); outline:none; transition:border-color 0.2s; box-shadow:var(--shadow-sm); }
  .mh-search:focus { border-color:var(--red); }
  .mh-search-icon { position:absolute; left:28px; top:50%; transform:translateY(-50%); color:var(--muted); font-size:16px; pointer-events:none; }
  .mh-search-clear { position:absolute; right:28px; top:61%; transform:translateY(-50%); background:none; border:none; color:var(--red);  cursor:pointer; padding:4px; line-height:1; }

  .mh-cats { padding:14px 0 10px; overflow-x:auto; display:flex; gap:8px; padding-left:16px; scrollbar-width:none; }
  .mh-cats::-webkit-scrollbar { display:none; }
  .mh-cat-pill { flex-shrink:0; display:flex; flex-direction:column; align-items:center; gap:5px; cursor:pointer; outline:none; border:none; background:none; padding:0; transition:transform 0.15s; }
  .mh-cat-pill:active { transform:scale(0.94); }
  .mh-cat-img-wrap { width:58px; height:58px; border-radius:50%; overflow:hidden; border:2.5px solid transparent; transition:border-color 0.2s,box-shadow 0.2s; background:#fff; box-shadow:var(--shadow-sm); display:flex; align-items:center; justify-content:center; }
  .mh-cat-pill.active .mh-cat-img-wrap { border-color:var(--red); box-shadow:0 0 0 3px rgba(200,16,46,0.15); }
  .mh-cat-img { width:100%; height:100%; object-fit:cover; }
  .mh-cat-name { font-size:10px; font-weight:600; color:var(--slate); text-align:center; max-width:64px; line-height:1.2; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
  .mh-cat-pill.active .mh-cat-name { color:var(--red); }

  .mh-section-head { padding:14px 16px 8px; font-family:var(--font-display); font-size:20px; font-weight:700; color:var(--charcoal); border-bottom:2px solid var(--red); margin-bottom:2px; letter-spacing:-0.3px; }

  .mh-prod-list { padding:0 16px; display:flex; flex-direction:column; gap:12px; margin-bottom:16px; }

  .mh-prod-card { background:#fff; border-radius:var(--radius); box-shadow:var(--shadow-sm); display:flex; align-items:center; gap:12px; padding:10px; transition:box-shadow 0.2s,transform 0.15s; position:relative; overflow:hidden; margin-top:5px; }
  .mh-prod-card.in-cart { box-shadow:0 0 0 2px var(--red),var(--shadow-sm); background:#fffaf9; }
  .mh-prod-card:active { transform:scale(0.985); }

  .mh-prod-img-wrap { position:relative; width:90px; height:90px; border-radius:12px; overflow:hidden; flex-shrink:0; background:#f0ebe5; }
  .mh-prod-img { width:100%; height:100%; object-fit:cover; display:block; }
  .mh-prod-img-skeleton { position:absolute; inset:0; background:linear-gradient(90deg,#f0ebe5 25%,#faf6f1 50%,#f0ebe5 75%); background-size:200% 100%; animation:shimmer 1.4s infinite; }
  @keyframes shimmer { to { background-position:-200% 0; } }

  .mh-veg-dot { position:absolute; top:5px; left:5px; width:14px; height:14px; border-radius:50%; border:2px solid #fff; box-shadow:0 1px 4px rgba(0,0,0,0.2); }
  .mh-veg-dot.veg { background:#16a34a; }
  .mh-veg-dot.nonveg { background:var(--red); }
  .mh-veg-dot.egg { background:#eab308; }
  .mh-new-badge { position:absolute; top:5px; right:5px; background:linear-gradient(135deg,#f97316,#dc2626); color:#fff; font-size:9px; font-weight:700; padding:2px 5px; border-radius:6px; text-transform:uppercase; letter-spacing:0.5px; }

  .mh-prod-info { flex:1; min-width:0; }
  .mh-prod-name { font-size:14px; font-weight:700; color:var(--charcoal); white-space:nowrap; overflow:hidden; text-overflow:ellipsis; margin-bottom:2px; }
  .mh-prod-desc { font-size:11px; color:var(--muted); display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden; line-height:1.4; margin-bottom:6px; }
  .mh-prod-prices { display:flex; align-items:baseline; gap:6px; }
  .mh-prod-price { font-size:17px; font-weight:800; color:var(--red); }
  .mh-prod-price-from { font-size:10px; color:var(--muted); font-weight:500; }
  .mh-prod-mrp { font-size:12px; color:var(--muted); text-decoration:line-through; font-weight:500; }

  .mh-add-btn { flex-shrink:0; background:var(--red); color:#fff; border:none; border-radius:10px; width:80px; height:36px; font-size:14px; font-weight:700; cursor:pointer; transition:background 0.15s,transform 0.1s; font-family:var(--font-body); display:flex; align-items:center; justify-content:center; }
  .mh-add-btn:active { transform:scale(0.92); background:var(--red-dk); }

  .mh-qty-wrap { flex-shrink:0; display:flex; align-items:center; gap:8px; }
  .mh-qty-btn { width:32px; height:32px; border-radius:8px; background:#f0ebe5; border:none; cursor:pointer; font-size:18px; font-weight:700; color:var(--charcoal); display:flex; align-items:center; justify-content:center; transition:background 0.15s,transform 0.1s; font-family:var(--font-body); }
  .mh-qty-btn:active { transform:scale(0.88); background:#e8e0d8; }
  .mh-qty-val { font-size:16px; font-weight:700; color:var(--charcoal); min-width:20px; text-align:center; }


.mh-footer { 
  background:var(--charcoal); 
  padding:12px 16px; 
  display:flex; 
  align-items:center; 
  justify-content:space-between; 
  gap:12px; 
  box-shadow:0 -4px 20px rgba(0,0,0,0.15); 
  width:100%; 
}
  .mh-footer-left { display:flex; flex-direction:column; gap:1px; }
  .mh-footer-items { font-size:11px; color:#aaa; font-weight:500; }
  .mh-footer-total { font-size:20px; font-weight:800; color:#fff; }
 .mh-footer-proceed {
  background: var(--red);
  color: #fff;
  border: none;
  padding: 13px 24px;
  border-radius: 14px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  font-family: var(--font-body);
  transition: background 0.15s, transform 0.1s;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
  .mh-footer-proceed:disabled { background:#555; cursor:not-allowed; }
  .mh-footer-proceed:not(:disabled):active { transform:scale(0.95); background:var(--red-dk); }

  .mh-filters { display:flex; gap:8px; padding:10px 16px 0; overflow-x:auto; scrollbar-width:none; }
  .mh-filters::-webkit-scrollbar { display:none; }
  .mh-filter-btn { flex-shrink:0; padding:7px 14px; border-radius:99px; border:1.5px solid #e8e0d8; background:#fff; color:var(--slate); font-size:12px; font-weight:600; cursor:pointer; font-family:var(--font-body); display:flex; align-items:center; gap:5px; transition:border-color 0.15s,background 0.15s,color 0.15s; white-space:nowrap; }
  .mh-filter-btn.active { border-color:var(--red); background:var(--red-lt); color:var(--red); }
  .mh-filter-dot { width:8px; height:8px; border-radius:50%; }
.mh-search-wrap {
  padding: 12px 16px 0;
  position: relative;
  transition: padding 0.35s ease;
}
.mh-search-focused .mh-search {
  border-color: var(--red);
  box-shadow: 0 0 0 3px rgba(200,16,46,0.12);
}
  @keyframes spin { to { transform:rotate(360deg); } }

  .mh-loader { position:fixed; inset:0; background:rgba(245,240,235,0.92); display:flex; align-items:center; justify-content:center; z-index:999; flex-direction:column; gap:14px; }
  .mh-loader-ring { width:56px; height:56px; border:4px solid #e8e0d8; border-top:4px solid var(--red); border-radius:50%; animation:spin 0.8s linear infinite; }
  .mh-loader-text { font-size:14px; color:var(--slate); font-weight:500; }

  .mh-empty { display:flex; flex-direction:column; align-items:center; justify-content:center; padding:60px 20px; text-align:center; gap:12px; }
  .mh-empty-icon { font-size:64px; }
  .mh-empty-text { font-size:16px; color:var(--muted); font-weight:500; }

  .mh-quit-overlay { position:fixed; inset:0; background:rgba(0,0,0,0.6); display:flex; align-items:center; justify-content:center; z-index:300; padding:20px; }
  .mh-quit-card { background:#fff; border-radius:24px; padding:28px 24px; text-align:center; width:100%; max-width:340px; box-shadow:0 16px 60px rgba(0,0,0,0.3); }
  .mh-quit-icon { font-size:48px; margin-bottom:12px; }
  .mh-quit-title { font-size:20px; font-weight:800; color:var(--charcoal); margin-bottom:8px; }
  .mh-quit-sub { font-size:14px; color:var(--muted); line-height:1.5; margin-bottom:20px; }
  .mh-quit-btns { display:flex; gap:10px; }
  .mh-quit-cancel { flex:1; padding:13px; border:1.5px solid #e0d8d0; border-radius:12px; background:#fff; font-size:15px; font-weight:700; color:var(--slate); cursor:pointer; font-family:var(--font-body); }
  .mh-quit-confirm { flex:1; padding:13px; background:var(--red); border:none; border-radius:12px; color:#fff; font-size:15px; font-weight:700; cursor:pointer; font-family:var(--font-body); }
  .mh-table-badge { background:var(--red); color:#fff; font-size:10px; font-weight:700; padding:2px 8px; border-radius:99px; display:inline-block; margin-top:2px; text-transform:uppercase; letter-spacing:0.5px; }

  /* Cross-tab sync toast */
  .mh-sync-toast {
    position:fixed; top:70px; left:50%; transform:translateX(-50%);
    background:var(--charcoal); color:#fff;
    padding:8px 18px; border-radius:99px;
    font-size:12px; font-weight:600;
    z-index:500; white-space:nowrap;
    box-shadow:0 4px 16px rgba(0,0,0,0.25);
    animation:toastIn 0.3s ease;
    pointer-events:none;
  }
  @keyframes toastIn {
    from { opacity:0; transform:translateX(-50%) translateY(-8px); }
    to   { opacity:1; transform:translateX(-50%) translateY(0); }
  }
    
  @media screen and (min-width: 601px) {
  .menu-root, .mh-footer-wrap {
    max-width: 100% !important;
    width: 100% !important;
  }
  .mh-header .mh-top { height: 68px !important; }
  .mh-banner { height: 260px !important; }
  .mh-cat-img-wrap { width: 70px !important; height: 70px !important; }
  .mh-cat-name { font-size: 12px !important; max-width: 80px !important; }
  .mh-prod-list {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 16px !important;
  }
    
}
@media screen and (min-width: 1200px) {
  .mh-prod-list { grid-template-columns: repeat(3, 1fr) !important; }
  .mh-banner { height: 300px !important; }
}
@media screen and (min-width: 601px) and (orientation: landscape) {
  .mh-banner { height: 190px !important; }
  .menu-root, .mh-footer-wrap { max-width: 100% !important; }
}
  .mh-banner.mh-banner-collapsed {
  height: 0 !important;
  transition: height 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}
    
`;

if (!document.getElementById("mh-global-css")) {
  const el = document.createElement("style");
  el.id = "mh-global-css";
  el.textContent = GLOBAL_CSS;
  document.head.appendChild(el);
}

// ── Helpers ───────────────────────────────────
const ProdImage = React.memo(({ src, alt }) => {
  const [loaded, setLoaded] = useState(false);
  return (
    <div className="mh-prod-img-wrap">
      {!loaded && <div className="mh-prod-img-skeleton" />}
      <img className="mh-prod-img" src={src} alt={alt} loading="lazy"
        onLoad={() => setLoaded(true)} onError={() => setLoaded(true)}
        style={{ opacity: loaded ? 1 : 0, transition: "opacity 0.3s" }} />
    </div>
  );
});

const VegDot = ({ type }) => {
  if (!type || type === 0) return null;
  return <span className={`mh-veg-dot ${type === 1 ? "veg" : type === 2 ? "nonveg" : "egg"}`} />;
};

const toSec = (t) => {
  if (!t) return 0;
  const [h = 0, m = 0, s = 0] = t.split(":").map(Number);
  return h * 3600 + m * 60 + s;
};

// ✅ Always read the latest cart from localStorage
const readCart = () => {
  try { return JSON.parse(localStorage.getItem("cart") || "[]"); }
  catch { return []; }
};

// ─────────────────────────────────────────────
//  MAIN COMPONENT
// ─────────────────────────────────────────────
function AboutPage() {
  const navigate = useNavigate();

  const [categories, setCategories]           = useState([]);
  const [productsByCategory, setProductsByCategory] = useState({});
  const [activeCategory, setActiveCategory]   = useState(0);

  // ✅ Init cart from localStorage (handles refresh + new tab open)
  const [cart, setCart]                       = useState(readCart);

  const [loading, setLoading]                 = useState(true);
  const [isSyncing, setIsSyncing]             = useState(false);
  const [searchTerm, setSearchTerm]           = useState("");
  const [bannerUrl, setBannerUrl]             = useState([]);
  const [activeBanner, setActiveBanner]       = useState(0);
  const [recommendedProducts, setRecommendedProducts] = useState([]);
  const [now, setNow]                         = useState(new Date());
  const [filterType, setFilterType]           = useState(null);
  const [priceSort, setPriceSort]             = useState(null);
  const [showQuit, setShowQuit]               = useState(false);
  const [syncToast, setSyncToast]             = useState(false);

  const catScrollRef = useRef(null);
  const catRefs      = useRef({});
  const clickCount   = useRef(0);
  const clickTimer   = useRef(null);
  const nowRef       = useRef(new Date());

  const compId    = localStorage.getItem("compId");
  const storeId   = localStorage.getItem("StoreId");
  const typeId    = localStorage.getItem("ordertypeId");
  const logo      = localStorage.getItem("logo");
  const storeName = localStorage.getItem("StoreName") || "Restaurant";
  const tableNo   = localStorage.getItem("qrTableNumber");
  const tableName   = localStorage.getItem("tableName");
const [searchFocused, setSearchFocused] = useState(false);
const [discount, setDiscount] = useState(0);
const [showTerms, setShowTerms] = useState(false);
const termHead = { fontSize: 13, fontWeight: 700, color: "var(--charcoal)", marginTop: 14, marginBottom: 4 };
const termP     = { fontSize: 12.5, color: "var(--slate)", marginBottom: 4 };
// add near other helpers (outside component, or inside before return)
const getEligibleDiscountAmt = (cartItems, discountPercent) => {
  if (!discountPercent || discountPercent <= 0) return 0;
  let amt = 0;
  cartItems.forEach((p) => {
    if (p.minquantity === 1) return; // excluded from discount
    const qty = p.quantity || 1;
    amt += ((p.sosPrice || 0) * qty * discountPercent) / 100;
  });
  return parseFloat(amt.toFixed(2));
};
const eligibleDiscountAmt = getEligibleDiscountAmt(cart, discount);
  // ── Clock ─────────────────────────────────
  useEffect(() => {
    const id = setInterval(() => {
      const n = new Date();
      setNow(n);
      nowRef.current = n;
    }, 1000);
    return () => clearInterval(id);
  }, []);

  // ══════════════════════════════════════════
  //  ✅ FIX 1 — CROSS-TAB SYNC
  //  The browser fires a "storage" event on
  //  every tab EXCEPT the one that wrote the
  //  value. So Tab B sees Tab A's cart update.
  // ══════════════════════════════════════════
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key !== "cart") return;           // ignore other keys
      const updated = e.newValue ? JSON.parse(e.newValue) : [];
      setCart(updated);                        // update this tab's state
      setSyncToast(true);
      setTimeout(() => setSyncToast(false), 2000);
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  // ══════════════════════════════════════════
  //  ✅ FIX 2 — RE-SYNC WHEN TAB REGAINS FOCUS
  //  Handles the case where the tab was in the
  //  background and missed storage events.
  // ══════════════════════════════════════════
  useEffect(() => {
    const onVisible = () => {
      if (document.visibilityState === "visible") {
        setCart(readCart());
      }
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => document.removeEventListener("visibilitychange", onVisible);
  }, []);

  // ── Banner rotation ───────────────────────
  useEffect(() => {
    if (bannerUrl.length < 2) return;
    const t = setInterval(() => setActiveBanner(p => (p + 1) % bannerUrl.length), 5000);
    return () => clearInterval(t);
  }, [bannerUrl.length]);

  useEffect(() => {
  if (storeId) {
    getStoreSeries(storeId)
      .then(res => { if (res?.discount > 0) setDiscount(res.discount); })
      .catch(() => {});
  }
}, [storeId]);
  // ── Fetch banner ──────────────────────────
  useEffect(() => {
    (async () => {
      try {
        const menuData = await getMenuContent(parseInt(compId));
        const banners = (Array.isArray(menuData.homeContents) ? menuData.homeContents : [])
          .filter(x => x.isActive && x.url).map(x => x.url);
        setBannerUrl(banners.length ? banners : ["https://bizdomfs.blob.core.windows.net/post-image/ac6a5329-8923-4d26-a6df-c3b14270ff60.webp"]);
      } catch {
        setBannerUrl(["https://bizdomfs.blob.core.windows.net/post-image/ac6a5329-8923-4d26-a6df-c3b14270ff60.webp"]);
      }
    })();
  }, [compId]);

  // ── Time availability ─────────────────────
  const isProductAvailable = useCallback((product) => {
    if (!product.isActiveTime || product.isActiveTime === 0) return true;
    if (!product.fromTime || !product.toTime) return true;
    const n = nowRef.current;
    const nowSec = toSec(`${String(n.getHours()).padStart(2,"0")}:${String(n.getMinutes()).padStart(2,"0")}:${String(n.getSeconds()).padStart(2,"0")}`);
    const start = toSec(product.fromTime);
    const end   = toSec(product.toTime);
    return start <= end ? (nowSec >= start && nowSec <= end) : (nowSec >= start || nowSec <= end);
  }, []);

  // ── Fetch data ────────────────────────────
  const fetchData = useCallback(async () => {
    if (!compId || !storeId || !typeId) { setLoading(false); return; }
    try {
      setLoading(true);
      const response = await getalldata(compId, storeId, typeId);
      if (response?.status !== 200) { setLoading(false); return; }

      const categoriesData  = response.categories    || [];
      const productsData    = response.products       || [];
      const addonsData      = response.addons         || [];
      const recommendedData = response.recomendedProd || [];
      const prodTimeData    = response.prodTime       || [];

      const timeSlotMap = {};
      prodTimeData.forEach(slot => {
        if (!timeSlotMap[slot.productId]) timeSlotMap[slot.productId] = [];
        timeSlotMap[slot.productId].push({ fromTime: slot.fromTime, toTime: slot.toTime, isActive: slot.isActive });
      });

      const transformedProducts = productsData.map(p => {
        const slots = timeSlotMap[p.posProdId] || [];
        const activeSlot = slots.find(s => s.isActive === true);
        return {
          id: p.id, product_Name: p.product_Name,
          product_Description: p.product_Description || "",
          product_Imageurl: p.product_Imageurl,
          sosCategroyId: p.sosCategroyId, prodType: p.prodType,
          pS_Prod_Id: p.pS_Prod_Id, sosPrice: p.sosPrice,
          tax1: p.tax1 || 0, tax2: p.tax2 || 0, tax3: p.tax3 || 0,
          isActive: p.isActive === true,
          sale: p.sale === true ? 1 : 0,
          recomended: p.recomended === true ? 1 : 0,
          parent: p.parent === 1 ? 1 : 0,
          freeQty: p.freeQty || 1, offerPri: p.offerPri || 0,
          minquantity: p.minquantity ?? null,
          fromTime: activeSlot?.fromTime || null,
          toTime:   activeSlot?.toTime   || null,
          isActiveTime: activeSlot ? 1 : 0,
          addons: addonsData.filter(a => a.sosProdId === p.id).map(a => ({
            id: a.id, name: a.name, price: a.sosPrice, sosPrice: a.sosPrice,
            imageurl: a.imageurl, tax1: a.tax1 || 0, tax2: a.tax2 || 0, tax3: a.tax3 || 0, qty: 1,
          })),
        };
      });
const sortedCategoriesData = [...categoriesData].sort((a, b) => {
  const aSort = a.sortId ?? Number.MAX_SAFE_INTEGER;
  const bSort = b.sortId ?? Number.MAX_SAFE_INTEGER;
  if (aSort !== bSort) return aSort - bSort;
  return (a.cat_Name || "").localeCompare(b.cat_Name || ""); // fallback tie-breaker
});
      const allCategory = { id: 0, cat_Name: "All", cat_Imageurl: "https://bizdomfs.blob.core.windows.net/post-image/ac6a5329-8923-4d26-a6df-c3b14270ff60.webp", isActive: true };
const allCategories = [
  allCategory,
  ...sortedCategoriesData.map(c => ({
    id: c.id, cat_Name: c.cat_Name, cat_Imageurl: c.cat_Imageurl, isActive: c.isActive === true,
  })),
];

      const grouped = {};
      allCategories.forEach(cat => { grouped[cat.id] = []; });
      transformedProducts.forEach(product => {
        if (grouped[product.sosCategroyId] !== undefined) grouped[product.sosCategroyId].push(product);
        grouped[0].push(product);
      });

      setProductsByCategory(grouped);
      setCategories(allCategories.filter(cat => cat.id === 0 || grouped[cat.id]?.length > 0));
      setRecommendedProducts(recommendedData.map(p => ({
        id: p.id, product_Name: p.product_Name, product_Description: p.product_Description || "",
        product_Imageurl: p.product_Imageurl, prodType: p.prodType, sosPrice: p.sosPrice,
        fromTime: p.fromTime, toTime: p.toTime,
        isActiveTime: p.isActiveTime === true ? 1 : 0,
        freeQty: p.freeQty || 1, tax1: p.tax1 || 0, tax2: p.tax2 || 0, tax3: p.tax3 || 0,
        sale: p.sale === true ? 1 : 0, isRec: true,
      })));
      setActiveCategory(0);
    } catch (e) {
      console.error("Error fetching menu data:", e);
    } finally {
      setLoading(false);
    }
  }, [compId, storeId, typeId]);

  useEffect(() => { if (compId && storeId && typeId) fetchData(); }, [fetchData]);

  // ══════════════════════════════════════════
  //  ✅ FIX 3 — updateQty writes to localStorage
  //  localStorage.setItem automatically triggers
  //  the "storage" event in all OTHER open tabs.
  //  No extra code needed — it's built into the
  //  browser's Web Storage API.
  // ══════════════════════════════════════════
  const updateQty = useCallback((product, newQty, addons = null) => {
    setCart(prev => {
      const existing = prev.find(i => i.id === product.id);
      let next;
      if (!newQty || newQty <= 0) {
        next = prev.filter(i => i.id !== product.id);
      } else {
        const updated = { ...product, quantity: newQty, addons: addons ?? existing?.addons ?? [] };
        next = existing
          ? prev.map(i => i.id === product.id ? updated : i)
          : [...prev, updated];
      }
      // ✅ This line triggers "storage" event in all OTHER tabs
      localStorage.setItem("cart", JSON.stringify(next));
      return next;
    });
  }, []);

  const getQty = useCallback((id) => {
    const item = cart.find(i => i.id === id);
    return item?.quantity || 0;
  }, [cart]);

  const getTotal = useCallback(() =>
    cart.reduce((sum, item) => {
      const addons = (item.addons || []).reduce((s, a) => s + (a.price || a.sosPrice || 0) * (a.qty || 1), 0);
      return sum + (item.sosPrice || 0) * (item.quantity || 1) + addons;
    }, 0),
  [cart]);

  const getVisibleProducts = (catId) => {
    let prods = (productsByCategory[catId] || []).filter(p => {
      if (!isProductAvailable(p)) return false;
     if (searchTerm) return (p.product_Name || "").trim().toLowerCase().includes(searchTerm.trim().toLowerCase());
      return true;
    });
    if (filterType === "veg")    prods = prods.filter(p => p.prodType === 1);
    if (filterType === "nonveg") prods = prods.filter(p => p.prodType === 2);
    if (filterType === "egg")    prods = prods.filter(p => p.prodType === 3);
    if (priceSort === "asc")  prods.sort((a, b) => (a.sosPrice || 0) - (b.sosPrice || 0));
    if (priceSort === "desc") prods.sort((a, b) => (b.sosPrice || 0) - (a.sosPrice || 0));
    return prods;
  };

  const handleAdd    = (product) => updateQty(product, 1, []);
  const handleSync   = async () => { setIsSyncing(true); setSearchTerm(""); try { await fetchData(); } catch(e){} finally { setIsSyncing(false); } };

  const handleLogoClick = () => {
    clickCount.current += 1;
    if (clickTimer.current) clearTimeout(clickTimer.current);
    if (clickCount.current >= 3) { clickCount.current = 0; return; }
    clickTimer.current = setTimeout(() => {
      clickCount.current = 0;
      if (cart.length > 0) setShowQuit(true); else navigate("/");
    }, 600);
  };

  const scrollCatIntoView = (id) => {
    setTimeout(() => {
      const el = catRefs.current[id];
      const container = catScrollRef.current;
      if (!el || !container) return;
      container.scrollTo({ left: el.offsetLeft - container.offsetWidth / 2 + el.offsetWidth / 2, behavior: "smooth" });
    }, 80);
  };

  const handleCatClick = (id) => { setActiveCategory(id); scrollCatIntoView(id); };

  const renderCard = (product, key) => {
    const qty    = getQty(product.id);
    const inCart = qty > 0;
    return (
      <div key={key || product.id} className={`mh-prod-card${inCart ? " in-cart" : ""}`}>
        <div style={{ position: "relative" }}>
          <ProdImage src={product.product_Imageurl} alt={product.product_Name} />
          <VegDot type={product.prodType} />
          {product.sale === 1 && <span className="mh-new-badge">New</span>}
        </div>
        <div className="mh-prod-info">
          <div className="mh-prod-name">{product.product_Name}</div>
          {product.product_Description && <div className="mh-prod-desc">{product.product_Description}</div>}
          <div className="mh-prod-prices">
            {product.offerPri > 0 && <span className="mh-prod-mrp">₹{product.offerPri}</span>}
            <span className="mh-prod-price">
              {product.sosPrice
                ? product.parent === 1
                  ? <><span className="mh-prod-price-from">from </span>₹{product.sosPrice}</>
                  : `₹${product.sosPrice}`
                : "—"}
            </span>
          </div>
        </div>
        <div>
          {qty === 0
            ? <button className="mh-add-btn" onClick={() => handleAdd(product)}>Add</button>
            : <div className="mh-qty-wrap">
                <button className="mh-qty-btn" onClick={() => updateQty(product, Math.max(0, qty - 1))}>−</button>
                <span className="mh-qty-val">{qty}</span>
                <button className="mh-qty-btn" onClick={() => updateQty(product, qty + 1)}>+</button>
              </div>
          }
        </div>
      </div>
    );
  };

  const renderContent = () => {
    if (activeCategory === 0) {
      const recVisible = recommendedProducts.filter(p => isProductAvailable(p));
      const sections = categories.filter(c => c.id !== 0).map(cat => ({ cat, prods: getVisibleProducts(cat.id) })).filter(s => s.prods.length > 0);
      if (recVisible.length === 0 && sections.length === 0) return <Empty />;
      return (
        <>
          {recVisible.length > 0 && <Section title="✨ Recommended">{recVisible.map(p => renderCard(p, `rec-${p.id}`))}</Section>}
          {sections.map(({ cat, prods }) => <Section key={cat.id} title={cat.cat_Name}>{prods.map(p => renderCard(p, `prod-${p.id}`))}</Section>)}
        </>
      );
    }
    const prods = getVisibleProducts(activeCategory);
    if (!prods.length) return <Empty />;
    return <Section title={categories.find(c => c.id === activeCategory)?.cat_Name || ""}>{prods.map(p => renderCard(p, `cat-prod-${p.id}`))}</Section>;
  };

  return (
    <div className="menu-root">

      {loading && (
        <div className="mh-loader">
          {logo && logo !== "null" ? (
            <div style={{ position:"relative", width:80, height:80, marginBottom:8 }}>
              <div style={{ position:"absolute", inset:0, borderRadius:"50%", border:"3px solid #e8e0d8", borderTop:"3px solid var(--red)", animation:"spin 0.9s linear infinite" }} />
              <img src={logo} alt="logo" style={{ position:"absolute", inset:6, width:"calc(100% - 12px)", height:"calc(100% - 12px)", borderRadius:"50%", objectFit:"cover" }} />
            </div>
          ) : <div className="mh-loader-ring" />}
          <span className="mh-loader-text">Loading menu…</span>
        </div>
      )}

      {/*  Cross-tab sync notification */}
      {syncToast && <div className="mh-sync-toast">🔄 Cart updated</div>}

      <div className="mh-header">
        <div className="mh-top">
          {logo && logo !== "null"
            ? <img className="mh-logo" src={logo} alt="logo" onClick={handleLogoClick} />
            : <div className="mh-logo-placeholder" onClick={handleLogoClick}>🍽</div>}
          {/* <div className="mh-info">
            <div className="mh-store">{storeName}</div>
            {tableNo && <span className="mh-table-badge">Table {tableNo}</span>}
          </div> */}
          <div className="mh-info">
  <div className="mh-store">
    {storeName}
    {/* <span style={{ fontSize: 10, color: "#fff", fontWeight: 500, marginLeft: 6 }}>
      V1
    </span> */}
  </div>
  {/* {tableName && <span className="mh-table-badge">{tableName}</span>} */}
   {/* <span className="mh-table-badge">
      V-1
    </span> */}
 <span className="mh-table-badge">Dine-In Only V-1</span>
</div>
           {/* <span className="mh-time"><FaRegClock style={{ fontSize: "14px", marginRight: "6px", verticalAlign: "middle" }} />{now.toLocaleTimeString("en-GB", { hour:"2-digit", minute:"2-digit" })}</span> */}
          {discount > 0 && (
  <div style={{
    background: "linear-gradient(135deg, #14532d, #166534)",
    border: "1px solid rgba(74,222,128,0.3)",
    borderRadius: 99,
    padding: "5px 12px",
    display: "flex",
    alignItems: "center",
    gap: 6,
    flexShrink: 0,
  }}>
    <span style={{ fontSize: 12, fontWeight: 800, color: "#4ade80", letterSpacing: 0.3 }}>
      Up to {discount}% OFF
    </span>
  </div>
)}
        </div>
      </div>

      {/* <div className="mh-banner" style={{
  height: searchFocused ? 0 : 180,
  overflow: "hidden",
  transition: "height 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
}}>
  {bannerUrl.map((url, i) => <img key={i} className="mh-banner-img" src={url} alt="banner" style={{ opacity: activeBanner === i ? 1 : 0 }} />)}
  <div className="mh-banner-overlay" />
  <div className="mh-banner-text"><h2>Explore Our Menu</h2><p>Freshly made with love</p></div>
</div> */}
<div className={`mh-banner${searchFocused ? " mh-banner-collapsed" : ""}`}>
  {bannerUrl.map((url, i) => (
    <img key={i} className="mh-banner-img" src={url} alt="banner"
      style={{ opacity: activeBanner === i ? 1 : 0 }} />
  ))}
  <div className="mh-banner-overlay" />
  <div className="mh-banner-text"><h2>Explore Our Menu</h2><p>Freshly made with love</p></div>
</div>
      <div className="mh-search-wrap">
      
    <input
  className="mh-search"
  type="text"
  placeholder="Search dishes..."
  value={searchTerm}
  enterKeyHint="search"
  onChange={e => setSearchTerm(e.target.value)}
  onFocus={() => setSearchFocused(true)}
  onBlur={() => {
    // Only collapse banner if search is empty
    if (!searchTerm) setSearchFocused(false);
  }}
  onKeyDown={e => {
    if (e.key === "Enter") e.target.blur();
  }}
/>
        {searchTerm && (
  <button className="mh-search-clear" onClick={() => {
    setSearchTerm("");
    setSearchFocused(false);
  }}>✕</button>
)}
      </div>


<div ref={catScrollRef} className="mh-cats"></div>
      <div ref={catScrollRef} className="mh-cats">
        {categories.map(cat => (
          <button key={cat.id} ref={el => el && (catRefs.current[cat.id] = el)}
            className={`mh-cat-pill${activeCategory === cat.id ? " active" : ""}`}
            onClick={() => handleCatClick(cat.id)}>
            <div className="mh-cat-img-wrap"><img className="mh-cat-img" src={cat.cat_Imageurl} alt={cat.cat_Name} loading="lazy" /></div>
            <span className="mh-cat-name">{cat.cat_Name}</span>
          </button>
        ))}
        <div style={{ flexShrink:0, width:8 }} />
      </div>

    <div className="mh-filters">
<button
  className={`mh-filter-btn ${priceSort ? "active" : ""}`}
  onClick={() =>
    setPriceSort(p => (p === null ? "asc" : p === "asc" ? "desc" : null))
  }
>
  {priceSort === "asc" ? (
    <>
      <MdArrowUpward size={14} /> Price
    </>
  ) : priceSort === "desc" ? (
    <>
      <MdArrowDownward size={14} /> Price
    </>
  ) : (
    <>
      <MdOutlineSort size={14} /> Price
    </>
  )}
</button>
  <button 
    className={`mh-filter-btn ${filterType === "veg" ? "active" : ""}`}
    onClick={() => setFilterType(filterType === "veg" ? null : "veg")}
  >
    <span className="mh-filter-dot" style={{ background: "#16a34a" }}></span>
    Veg
  </button>
  <button 
    className={`mh-filter-btn ${filterType === "nonveg" ? "active" : ""}`}
    onClick={() => setFilterType(filterType === "nonveg" ? null : "nonveg")}
  >
    <span className="mh-filter-dot" style={{ background: "#c8102e" }}></span>
    Non-Veg
  </button>
  <button 
    className={`mh-filter-btn ${filterType === "egg" ? "active" : ""}`}
    onClick={() => setFilterType(filterType === "egg" ? null : "egg")}
  >
    <span className="mh-filter-dot" style={{ background: "#eab308" }}></span>
    Egg
  </button>
</div>

<div style={{
  flex: 1,
  overflowY: "auto",
  paddingBottom: cart.length > 0 ? 90 : 24,
  transition: "padding-bottom 0.4s ease",
}}>
  {renderContent()}

  {/* Terms & Copyright footer — end of scrollable content */}
  <div style={{
    padding: "24px 16px 20px",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    gap: 6,
  }}>
    <button
      onClick={() => setShowTerms(true)}
      style={{
        background: "none",
        border: "none",
        color: "var(--red)",
        fontSize: 12,
        fontWeight: 600,
        cursor: "pointer",
        textDecoration: "underline",
        fontFamily: "var(--font-body)",
      }}
    >
      Terms & Conditions
    </button>
    <span style={{ fontSize: 10, color: "var(--muted)" }}>
      © {new Date().getFullYear()} Powered by BizDom Solutions
    </span>
  </div>
</div>
{showTerms && (
  <div className="mh-quit-overlay" onClick={() => setShowTerms(false)}>
    <div
      className="mh-quit-card"
      onClick={(e) => e.stopPropagation()}
      style={{ textAlign: "left", maxHeight: "78vh", overflowY: "auto", maxWidth: 420, position: "relative" }}
    >
      <button
        onClick={() => setShowTerms(false)}
        aria-label="Close terms and conditions"
        style={{
          position: "absolute",
          top: 12,
          right: 12,
          width: 30,
          height: 30,
          borderRadius: "50%",
          border: "none",
          background: "#f0ebe5",
          color: "var(--charcoal)",
          fontSize: 15,
          fontWeight: 700,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 2,
        }}
      >
        ✕
      </button>
      <div className="mh-quit-title" style={{ marginBottom: 4 }}>Terms & Conditions</div>
      {/* <div style={{ fontSize: 11, color: "var(--muted)", marginBottom: 16 }}>
        Last updated: {new Date().toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })}
      </div> */}

      <div style={{ fontSize: 13, color: "var(--slate)", lineHeight: 1.65 }}>

        <h4 style={termHead}>1. Ordering</h4>
        <p style={termP}>By scanning the QR code and placing an order, you confirm the order details, quantities, and add-ons shown before submission are accurate. Orders are sent directly to the restaurant kitchen once confirmed and cannot be edited after submission — please contact restaurant staff for changes.</p>

        <h4 style={termHead}>2. Pricing & Payment</h4>
        <p style={termP}>All prices are listed in ₹ (INR) and are inclusive of applicable taxes unless stated otherwise. Prices, offers, and discounts are subject to change without prior notice and may vary by outlet. Payment must be completed as instructed by restaurant staff at the time of order or checkout.</p>

        <h4 style={termHead}>3. Dine-In Orders</h4>
        <p style={termP}>This menu is intended for dine-in use only at the table/location where the QR code was scanned. Orders placed are associated with your current table session and may be cancelled if the session expires or the table changes.</p>

        <h4 style={termHead}>4. Food Allergies & Ingredients</h4>
        <p style={termP}>While we take reasonable care in preparing food, dishes may contain or come into contact with allergens including nuts, dairy, gluten, and eggs. Please inform restaurant staff of any allergies or dietary requirements before ordering, as we cannot guarantee a completely allergen-free environment.</p>

        <h4 style={termHead}>5. Order Availability</h4>
        <p style={termP}>Items shown as available may occasionally be out of stock due to real-time demand. The restaurant reserves the right to substitute, modify, or cancel an item and will notify you where possible.</p>

        <h4 style={termHead}>6. Cancellations & Refunds</h4>
        <p style={termP}>Once an order is confirmed and being prepared, cancellations may not be possible. Refunds, if applicable, are at the sole discretion of the restaurant and will be processed as per the outlet's policy.</p>

        <h4 style={termHead}>7. Service Charges & Discounts</h4>
        <p style={termP}>Any displayed discount is applied automatically at checkout and is valid only for the current session unless otherwise stated. Service charges, if applicable, will be shown separately before final payment.</p>

        <h4 style={termHead}>8. Limitation of Liability</h4>
        <p style={termP}>The restaurant and platform provider are not liable for indirect, incidental, or consequential damages arising from the use of this ordering system, including delays, technical errors, or connectivity issues.</p>

        <h4 style={termHead}>9. Data & Privacy</h4>
        <p style={termP}>Information collected during ordering (such as table number and order history) is used solely to process your order and improve service. We do not sell your personal data to third parties.</p>

        <h4 style={termHead}>10. Changes to Terms</h4>
        <p style={termP}>These terms may be updated periodically without prior notice. Continued use of this ordering system constitutes acceptance of the revised terms.</p>

        <h4 style={termHead}>11. Contact</h4>
        <p style={{ ...termP, marginBottom: 0 }}>For questions regarding these terms, please speak with restaurant staff directly or contact support through the outlet.</p>

      </div>

      <button
        className="mh-quit-confirm"
        style={{ marginTop: 20, width: "100%" }}
        onClick={() => setShowTerms(false)}
      >
        I Understand
      </button>
    </div>
  </div>
)}
      {/* FOOTER — only shows when cart has items */}

<div className="mh-footer-wrap" style={{
  position: "fixed",
  bottom: 0,
  left: "50%",
  transform: cart.length > 0
    ? "translateX(-50%) translateY(0)"
    : "translateX(-50%) translateY(120%)", // ✅ 120% ensures fully hidden
  width: "100%",
  maxWidth: 480,
  transition: "transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)",
  zIndex: 100,
  pointerEvents: cart.length > 0 ? "auto" : "none", // ✅ not clickable when hidden
}}>
  <div className="mh-footer">
    <div className="mh-footer-left">
      <span className="mh-footer-items">
        {cart.reduce((sum, i) => sum + (i.quantity || 1), 0)} item{cart.reduce((sum, i) => sum + (i.quantity || 1), 0) !== 1 ? "s" : ""}
      </span>
     <span className="mh-footer-total">₹{getTotal().toFixed(2)}</span>
{/* {discount > 0 && (
  <span style={{ fontSize: 11, color: "#4ade80", fontWeight: 700 }}>
  🏷️
    {discount}% OFF at checkout 
  </span>
)} */}
{eligibleDiscountAmt > 0 && (
  <span style={{
    fontSize: 10, fontWeight: 700,
    color: "#4ade80",
    display: "flex", alignItems: "center", gap: 3,
  }}>
    🏷️ {discount}% OFF applied at checkout
  </span>
)}
    </div>
    <button
  className="mh-footer-proceed"
  onClick={() => {
    if (cart.length === 0) return;
    localStorage.setItem("lastActiveCategory", String(activeCategory));
    navigate("/cart");
  }}
>
  <span>View Cart</span>
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6" />
  </svg>
</button>
  </div>
</div>

      {showQuit && (
        <div className="mh-quit-overlay">
          <div className="mh-quit-card">
            <div className="mh-quit-icon">🏠</div>
            <div className="mh-quit-title">Go to Home?</div>
            <div className="mh-quit-sub">Your cart will be cleared. Continue?</div>
            <div className="mh-quit-btns">
              <button className="mh-quit-cancel" onClick={() => setShowQuit(false)}>Stay</button>
              <button className="mh-quit-confirm" onClick={() => { localStorage.removeItem("cart"); localStorage.removeItem("orderType"); localStorage.removeItem("ordertypeId"); navigate("/"); }}>Yes, Go Home</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const Section = ({ title, children }) => (
  <div>
    <div className="mh-section-head">{title}</div>
    <div className="mh-prod-list">{children}</div>
  </div>
);

const Empty = () => (
  <div className="mh-empty">
    <div className="mh-empty-icon">🍽️</div>
    <div className="mh-empty-text">No items found</div>
  </div>
);


export default AboutPage;